
/* injects from baggage-loader */

'use strict';

import AdminHomeComponent from './admin.home.component';

const AdminHomePageModule = angular.module('admin-home-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('admin.home', {
        url: '/home',
        // Requires valid login to view
        protected: true,
        component: 'adminHome',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('adminHome', new AdminHomeComponent());

export default AdminHomePageModule;



// WEBPACK FOOTER //
// ./src/app/pages/admin/home/admin.home.module.js